import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { selectV2Theme } from "../selectV2Theme";

export const ContentBeforeContainer = styled("div")<{
    themeMode: RequiredThemeKeys;
    isContentBeforeVisible?: boolean;
}>`
    width: ${({ themeMode }) => selectV2Theme.contentBefore.width(themeMode)};
    display: flex;
    align-self: var(--sds--content--before--container--align-self);
    align-items: center;
    justify-content: center;
    flex: ${({ themeMode }) => selectV2Theme.contentBefore.flex(themeMode)};
    margin-top: var(--sds--content--before--container--margin-top, -1px);
`;
